// BookTickets/lib/dom.ts

export function insertScript(url: string, async = true, onload?: (() => void) | false) {
  if (typeof document === 'undefined') return

  const script = document.createElement('script')
  script.src = url
  script.async = async
  if (onload) script.onload = onload

  document.body.appendChild(script)
}
